const supplierBooking = {
    SupplierBookingStatus: {
        SupplierBookingStatusType: {
            Name: true,
            Caption: true,
            Color: true,
            LocalizedCaption: true,
        },
    },
    SupplierHotel: {
        Id: true,
        Name: true,
        Hotel: {
            Address: true,
            HotelCategory: {
                Key: true,
                Caption: true,
                LocalizedCaption: true,
                RatingNumber: true,
            },
            CheckInHour: true,
            CheckOutHour: true,
        },
        SupplierHotelImages: {
            Id: true,
            Caption: true,
            Feature: true,
            Published: true,
            HotelImageType: { Id: true, Key: true },
            VirtualPath: true,
        },
    },
    Cancelled: true,
    BookingCode: true,
    CheckInDate: true,
    CheckOutDate: true,
    BookingDate: true,
    Nights: true,
    Paxes: true,
    TotalAmount: true,
    Currency: {
        Key: true,
    },
    SupplierBookingPaymentInfo: {
        CreditCardNumberObfuscated: true,
        HolderName: true,
        HolderSurname: true,
        IdVirtualCreditCard: true,
        VirtualCreditCard: {
            CVV: true,
            CardNumber: true,
        },
    },
    Payments: {
        ZoeBookingPaymentStatus: {
            ZoeBookingPaymentStatusType: {
                Key: true,
            },
        },
        Amount: true,
        Currency: {
            Name: true,
        },
        SupplierBooking: {
            Id: true,
            BookingCode: true,
        },
        PaymentMethod: {
            Key: true,
        },
    },
    ReservationIDs: {
        ResID_Value: true,
        OTAReferenceTableCode: {
            Key: true,
            Name: true,
        },
    },
    SupplierBookingRequest: true,
    Rooms: {
        SupplierHotelMealPlan: {
            Name: true,
            MappingCode: true,
        },
        SupplierHotelRoomType: {
            Name: true,
            Description: true,
            MappingCode: true,
            SupplierHotelRoomTypeDescriptions: {
                ContentLanguage: {
                    Name: true,
                    Caption: true,
                    LocalizedCaption: true,
                    CultureId: true,
                },
                Description: true,
                Id: true,
                IdContentLanguage: true,
                DescriptionType: {
                    Key: true,
                    Caption: true,
                    LocalizedCaption: true,
                },
            },
        },
        Paxes: {
            Age: true,
            Name: true,
            Surname: true,
            IsAdult: true,
            IsBaby: true,
            IsChild: true,
        },
        Rates: {
            AmountAfterTax: true,
        },
        SupplierHotelRatePlan: {
            MappingCode: true,
            Name: true,
        },
        Supplements: {
            Amount: true,
            Currency: {
                Key: true,
            },
            SupplierSupplement: {
                Description: true,
                Name: true,
                OnlyAdults: true,
                OnlyChildren: true,
                ShowToCustomer: true,
                SupplierTaxCalculationRuleType: {
                    Key: true,
                    Caption: true,
                    LocalizedCaption: true,
                    Name: true,
                },
                SupplierTaxCalculationType: {
                    Key: true,
                    Caption: true,
                    LocalizedCaption: true,
                    Name: true,
                },
            },
        },
        Taxes: {
            Amount: true,
            Currency: {
                Key: true,
            },

            SupplierTax: {
                Name: true,
                OnlyAdults: true,
                OnlyChildren: true,
                Description: true,
                SupplierTaxCalculationRuleType: {
                    Name: true,
                    Caption: true,
                    LocalizedCaption: true,
                    Key: true,
                },
                SupplierTaxCalculationType: {
                    Name: true,
                    Caption: true,
                    LocalizedCaption: true,
                    Key: true,
                },
            },
        },
    },
    Remarks: true,
    SupplierBookingCancellationPolicy: {
        DecodedPenalties: true,
    },
    ZoeBooking: {
        ExternalReferenceCodes: true,
        EndCustomer: {
            FullName: true,
            EmailAddress: true,
        },
    },
};

export default supplierBooking;
